import { useMutation, useQuery, useQueryClient } from "react-query";
import DevSdkRepoAPI from "../api/DevSdkRepo";
import { CustomToast } from "../util/custom-toast/CustomToast";
import { hideLoader, showLoader } from "../util/loader/CustomLoader";

export const useGetSdkRepo = (offset = 0, pageSize = 100) => {
  const { data, isLoading, isError } = useQuery(
    ["getSdkRepo", offset, pageSize],
    async () => {
      let api = new DevSdkRepoAPI();
      const res = await api.getAllSdkRepo(offset, pageSize);
      return res.data.data;
    },
    {
      onMutate: () => {
        showLoader();
      },
      onSuccess: () => {
        hideLoader();
      },
      onError: (error) => {
        hideLoader();
        CustomToast(error.response.data.message);
      },
    }
  );
  return { data, isLoading, isError };
};

export const useGetOneSdkRepo = () => {
  const { mutate, data, isLoading, isError } = useMutation(
    async (id) => {
      let api = new DevSdkRepoAPI();
      const res = await api.getOneSdkRepo(id);
      return res?.data?.data;
    },
    {
      onMutate: () => {
        showLoader();
      },
      onSuccess: () => {
        hideLoader();
      },
      onError: (error) => {
        hideLoader();
        CustomToast(error.response.data.message);
      },
    }
  );
  return { mutate, data, isLoading, isError };
};

export const useGetDownloadUrl = () => {
  const { mutate, data, isLoading, isError } = useMutation(
    async ({ repoId, packageId }) => {
      let api = new DevSdkRepoAPI();
      const res = await api.getPackageDownloadUrl(repoId, packageId);
      return res.data.data;
    },
    {
      onMutate: () => {
        showLoader();
      },
      onSuccess: () => {
        hideLoader();
      },
      onError: (error) => {
        hideLoader();
        CustomToast(error.response.data.message);
      },
    }
  );
  return { mutate, data, isLoading, isError };
};
